import http from "../http-common";

class ParserService {
  urlParser(data) {
    return http.post("/parsers/url-parser", data);
  }
}

export default new ParserService();
